import { HotkeyItem, useHotkeys } from '@mantine/hooks';
import { useModals } from '@mantine/modals';

import { openPatientSpotlight } from '@/components/searchPatient/patient-spotlight-store.ts';

import { Shortcut } from '@/constants/shortcuts.ts';

import { openAppointmentScheduler } from '@/utils/modal/appointmentSchedulerUtils.tsx';
import { openWalkInModal } from '@/utils/modalUtils.tsx';

export const useGlobalHotkeys = (): void => {
    const { modals } = useModals();
    const isOtherModalOpen = modals.some((modal) => modal.id);

    const handleOpenPatientSpotlight = (): void => {
        if (isOtherModalOpen) return;

        openPatientSpotlight();
    };

    const handleOpenWalkInModalInBookMode = (): void => {
        if (isOtherModalOpen) return;

        openWalkInModal(() => openAppointmentScheduler({ mode: 'book' }));
    };

    const hotkeys: HotkeyItem[] = [
        [Shortcut.WALK_IN_MODAL, handleOpenWalkInModalInBookMode],
        [Shortcut.PATIENT_SEARCH_SPOTLIGHT, handleOpenPatientSpotlight],
    ];

    useHotkeys(hotkeys);
};
